import { Strong as XcoreJsUiStrong } from "@xcorejs/ui";
import { forwardRef } from "react";
import { XcoreJsUiTypographyProps } from "./types";

export const Strong = forwardRef<HTMLDivElement, Omit<XcoreJsUiTypographyProps, "as" | "variant" | "v">>(({ children, ...props }, ref) => (
  // @ts-ignore
  <XcoreJsUiStrong {...props} ref={ref} placeholder="">
    {children}
  </XcoreJsUiStrong>
));

Strong.displayName = "Strong";
